import React from 'react'
import ReactDOM from 'react-dom/client'

import { UserProvider } from './contexts/UserContext'
import Routers from './Routers'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <UserProvider>
    <Routers />
  </UserProvider>
)
